import React, { Component } from 'react';
import history from './History';
import { BrowserRouter, Router, Route, Switch} from 'react-router-dom'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { Grid, Row, Col } from 'react-flexbox-grid';
import PrivateRoute from './components/PrivateRoute';
import Nav from './components/Nav';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Auth from './components/auth/Auth';
import NotFound from './components/NotFound';
import Forgot from './components/auth/Forgot';
import Home from './components/Home';
import Paypal from './components/Paypal';
import About from './components/About';
import Contact from './components/Contact';
import Review from './components/Review';
import Dashboard from './components/Dashboard';
import { LoginSnack, QuoteSnack } from './components/Snacks';

import {
  lime900,
  cyan500, cyan700,
  pinkA200,
  grey100, grey300, grey400, grey500, grey700,
  white, darkBlack, fullBlack,
} from 'material-ui/styles/colors';

const muiThemeObject = {
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: "#8c0808",
    primary2Color: cyan700,
    primary3Color: grey400,
    accent1Color: lime900,
    accent2Color: grey100,
    accent3Color: grey500,
    pickerHeaderColor: cyan500, 
    textColor: darkBlack,
    alternateTextColor: "#f3f2f0",
    appBar: {
      height: 900,
    },
  },
};
const muiTheme = getMuiTheme(muiThemeObject);

class App extends Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <Router history={history}>
          <div>
            <Route component={Nav} />
            <Switch>
              <Route exact path='/' component={Home} />
              <Route path='/Login' component={Login} />
              <Route path='/Register' component={Register} />
              <PrivateRoute path='/Dashboard' component={Dashboard} />
              {/* 
              <Route path='/Forgot' render={(props) => 
                <CenteredCard {...props} 
                  title="Password Reset" 
                  text="An email has been sent to your inbox that will allow you to reset your password."
                />}
              /> */}
              <Route path='/About' component={About} />
              <Route path='/Contact' component={Contact} />
              <Route path='/Pay' component={Paypal} />
              <Route path='/Review' component={Review} />
              {/* <Route component={Auth}>
              </Route>              <Route component={NotFound}/>*/}
 
            </Switch>
            <LoginSnack />
            <QuoteSnack />
          </div>
        </Router>
      </MuiThemeProvider>
    );
  }
}

export default App;

const Footer = props => (
    <Grid fluid>
        <Row>
          <Col xs={12} sm={4}>
            <h5>About</h5>
            <h5>Contact</h5>
            <h5>Help</h5>
          </Col>
        </Row>
    </Grid>
);


// WEBPACK FOOTER //
// ./src/App.js